import { DebtorComponent } from "projects/reg-hub-client/src/app/orders/debtor/debtor.component";
import { KnowYourCustomerCriteriaReviewComponentComponent } from "projects/reg-hub-client/src/app/orders/know-your-customer-criteria-review-component/know-your-customer-criteria-review-component.component";
import { KnowYourCustomerCriteriaComponent } from "projects/reg-hub-client/src/app/orders/know-your-customer-criteria/know-your-customer-criteria.component";
import { Step, StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { Stepper } from "projects/reg-hub-client/src/interfaces/stepper";

export class _MKnowYourCustomerStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Options", content: KnowYourCustomerCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Criteria", content: DebtorComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: KnowYourCustomerCriteriaReviewComponentComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}